// Fulfillment Api
import { http } from "./http";

export const getFulfillmentByOrderId = async (orderId: number) => {
  const res = await http.get(`/api/admin/orders/${orderId}/fulfillment`);
  return res.data.fulfillment;
};

export const getFulfillmentById = async (fulfillmentId: number) => {
  const res = await http.get(`/api/admin/fulfillments/${fulfillmentId}`);
  return res.data.fulfillment;
};

export const startFulfillment = async (fulfillmentId: number) => {
  const res = await http.post(`/api/admin/fulfillments/${fulfillmentId}/start`);
  return res.data;
};

export const markReady = async (fulfillmentId: number) => {
  const res = await http.post(`/api/admin/fulfillments/${fulfillmentId}/mark-ready`);
  return res.data;
};

export const completeFulfillment = async (
  fulfillmentId: number,
  payload?: {
    carrier?: string | null;
    tracking_number?: string | null;
    tracking_url?: string | null;
    note?: string | null;
  }
) => {
  const res = await http.post(
    `/api/admin/fulfillments/${fulfillmentId}/complete`,
    payload || {}
  );
  return res.data;
};

export const markDelivered = async (
  fulfillmentId: number,
  deliveryMessage?: string | null
) => {
  const res = await http.post(`/api/admin/fulfillments/${fulfillmentId}/delivered`, {
    delivery_message: deliveryMessage || null,
  });
  return res.data;
};

export type Driver = {
  id: number;
  name: string;
  phone: string;
  email?: string | null;
  vehicle_type?: string | null;
  status: string;
};

export const listDrivers = async () => {
  const res = await http.get("/api/admin/drivers");
  return res.data.drivers as Driver[];
};

export const assignDriverToFulfillment = async (fulfillmentId: number, driver_id: number) => {
  const res = await http.post(`/api/admin/fulfillments/${fulfillmentId}/assign-driver`, {
    driver_id,
  });
  return res.data;
};

export const buyShippingLabel = async (payload: {
  fulfillmentId: number;
  orderId: number;
  service_code?: string;
  package?: { weightOz: number; lengthIn: number; widthIn: number; heightIn: number };
}) => {
  const res = await http.post("/api/admin/shipping/labels", payload);
  return res.data as {
    success: boolean;
    carrier?: string;
    tracking_number?: string;
    tracking_url?: string;   // ✅ carrier tracking page
    label_url?: string;      // ✅ PDF label link
    fulfillment_label_id?: number; // ✅ your DB row id (optional)
    shippo_transaction_id?: string; // ✅ optional
    raw?: any;
  };
};

export const refundShippingLabel = async (labelId: number) => {
  const res = await http.post(`/api/admin/shipping/labels/${labelId}/refund`);
  return res.data as {
    success: boolean;
    refund?: any;
  };
};

// ✅ Rates (typed)
export type ShippingRate = {
  service_code: string;
  service_type?: string;
  carrier_code?: string;
  delivery_days?: number;
  estimated_delivery_date?: string;
  total_amount?: { amount: number; currency: string };
};

export const getShippingRates = async (payload: {
  orderId: number;
  package?: { weightOz: number; lengthIn: number; widthIn: number; heightIn: number };
}) => {
  const res = await http.post("/api/admin/shipping/rates", payload);
  return res.data as {
    shipFrom: any;
    shipTo: any;
    rates: ShippingRate[];
  };
};

export type FulfillmentLabel = {
  id: number;
  fulfillment_id: number;
  provider: string;
  carrier?: string | null;
  tracking_number?: string | null;
  tracking_url?: string | null;
  label_url?: string | null;
  label_file_type?: string | null;
  shippo_transaction_id?: string | null;
  shippo_rate_id?: string | null;
  shipping_cost_cents?: number | null;
  shipping_cost_currency?: string | null;
  status?: string | null;
  raw?: any;
created_at: string;
updated_at?: string;
};

export const getLatestFulfillmentLabel = async (fulfillmentId: number) => {
  const res = await http.get(`/api/admin/fulfillments/${fulfillmentId}/labels/latest`);
  return res.data.label as FulfillmentLabel | null;
};

export const getFulfillmentLabels = async (fulfillmentId: number) => {
  const res = await http.get(`/api/admin/fulfillments/${fulfillmentId}/labels`);
  return res.data.labels as FulfillmentLabel[];
};

// Add to your fulfillmentApi.ts
export const updatePackingNotes = async (fulfillmentId: number, packing_notes: string) => {
  const res = await http.post(`/api/admin/fulfillments/${fulfillmentId}/notes`, {
    packing_notes,
  });
  return res.data;
};